export const roundDownNumberOfCompanies = (number) => {
    if (number > 100) {
        return Math.floor(number / 100) * 100;
    }
    if (number > 10) {
        return Math.floor(number / 10) * 10;
    }
    return number;
};
